export const LEADUNIT_SELECTION = {
	start: 'fetch_start/leadunit_selection',
	end: 'fetch_end/leadunit_selection',
	success: 'fetch_success/leadunit_selection',
	failed: 'fetch_failed/leadunit_selection',
	setLead: 'set_current_lead'
};
// On lad unit Select
export const leadUnitSelectionFetchStart = () => ({
	type: LEADUNIT_SELECTION.start
});

export const leadUnitSelectionFetchEnd = () => ({
	type: LEADUNIT_SELECTION.end
});

export const leadUnitSelectionFetchSuccess = (leadunit) => (
	{
		type: LEADUNIT_SELECTION.success,
		leadunit
	});

export const leadUnitSelectionFetchFailed = (error) => ({
	type: LEADUNIT_SELECTION.failed,
	error
});
export const updateCurrentLeadUnit = (leadunit) => ({
	type: LEADUNIT_SELECTION.setLead,
	leadunit
});
export const setCurrentLeadUnit = (leadunit) => (dispatch) => {
	dispatch(updateCurrentLeadUnit(leadunit));
};


// WEBPACK FOOTER //
// ./shared/actions/leadSelection.js